import Vue from "vue";
import { userManager, isAuthenticated } from "../aws";

export default async function authHeader() {
  const user = await userManager.getUser();
  if (!user || user.expired) {
    return null; // Not logged in or token expired
  }
  let accessToken =  user.access_token;
  if (accessToken) {
    return { Authorization: "Bearer " + accessToken };
  }
}
